import { SectionName } from "@/entities/dossier-settings";
import { createContext, useContext } from "react";

export type SectionsContextType = {
    isSectionEnabled: (sectionName: SectionName) => boolean;
    isSectionInUse: (sectionName: SectionName) => boolean;
    isPending: boolean;
    error: Error | null;
};

export const SectionsContext = createContext<SectionsContextType | null>(null);

export const useSectionsContext = (): SectionsContextType => {
    const context = useContext(SectionsContext);
    if (!context) {
        throw new Error("useSectionsContext must be used within a SectionsProvider");
    }
    return context;
};
